import { Component, OnInit } from '@angular/core';

import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-manual-exhibit-ranking',
  templateUrl: './manual-exhibit-ranking.component.html',
  styleUrls: ['./manual-exhibit-ranking.component.css'],
  standalone: false,
})
export class ManualExhibitRankingComponent implements OnInit {

  readonly manualTopLink: string = AppConst.ROUTING_LINK_MANUAL_INDEX;

  currentLang: string = 'ja';

  constructor(
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.currentLang = this.translate.currentLang;
  }

}
